import type { MultilingualQuestion } from '../../types/multilingualQuestion';

// Multilingual version of Motorway Rules questions
export const motorwayRulesMultilingual: MultilingualQuestion[] = [
  {
    id: 'q-mr-1',
    text: {
      en: 'What is the minimum speed limit on a motorway in the Netherlands?',
      nl: 'Wat is de minimumsnelheid op een snelweg in Nederland?',
      ar: 'ما هي الحد الأدنى للسرعة على طريق سريع في هولندا؟'
    },
    options: [
      {
        id: 'q-mr-1o1',
        text: {
          en: '50 km/h',
          nl: '50 km/u',
          ar: '50 كم/س'
        }
      },
      {
        id: 'q-mr-1o2',
        text: {
          en: '60 km/h',
          nl: '60 km/u',
          ar: '60 كم/س'
        }
      },
      {
        id: 'q-mr-1o3',
        text: {
          en: '70 km/h',
          nl: '70 km/u',
          ar: '70 كم/س'
        }
      },
      {
        id: 'q-mr-1o4',
        text: {
          en: '80 km/h',
          nl: '80 km/u',
          ar: '80 كم/س'
        }
      }
    ],
    correctAnswerId: 'q-mr-1o2',
    explanation: {
      en: 'The minimum speed limit on a motorway in the Netherlands is 60 km/h. Vehicles that cannot maintain this speed are not allowed on motorways.',
      nl: 'De minimumsnelheid op een snelweg in Nederland is 60 km/u. Voertuigen die deze snelheid niet kunnen handhaven zijn niet toegestaan op snelwegen.',
      ar: 'الحد الأدنى للسرعة على طريق سريع في هولندا هو 60 كم/س. المركبات التي لا تستطيع الحفاظ على هذه السرعة غير مسموحة على الطرق السريعة.'
    },
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-speed-limit.jpg'
  },
  {
    id: 'q-mr-2',
    text: {
      en: 'Which vehicles are not allowed on motorways?',
      nl: 'Welke voertuigen zijn niet toegestaan op snelwegen?',
      ar: 'أي مركبات غير مسموحة على الطرق السريعة؟'
    },
    options: [
      {
        id: 'q-mr-2o1',
        text: {
          en: 'Motorcycles',
          nl: 'Motorfietsen',
          ar: 'الدراجات النارية'
        }
      },
      {
        id: 'q-mr-2o2',
        text: {
          en: 'Mopeds and tractors',
          nl: 'Bromfietsen en tractoren',
          ar: 'الدراجات البخارية والجرارات'
        }
      },
      {
        id: 'q-mr-2o3',
        text: {
          en: 'Cars towing trailers',
          nl: 'Auto\'s met aanhanger',
          ar: 'السيارات التي تسحب مقطورات'
        }
      },
      {
        id: 'q-mr-2o4',
        text: {
          en: 'All of the above',
          nl: 'Alle bovenstaande',
          ar: 'كل ما سبق'
        }
      }
    ],
    correctAnswerId: 'q-mr-2o2',
    explanation: {
      en: 'Mopeds and tractors are not allowed on motorways as they cannot maintain the minimum speed limit and would create a safety hazard.',
      nl: 'Bromfietsen en tractoren zijn niet toegestaan op snelwegen omdat ze de minimumsnelheid niet kunnen handhaven en een veiligheidsrisico zouden vormen.',
      ar: 'الدراجات البخارية والجرارات غير مسموحة على الطرق السريعة لأنها لا تستطيع الحفاظ على الحد الأدنى للسرعة وستشكل خطرا على السلامة.'
    },
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-prohibited-vehicles.jpg'
  },
  {
    id: 'q-mr-3',
    text: {
      en: 'What should you do if your vehicle breaks down on a motorway?',
      nl: 'Wat moet je doen als je voertuig pech krijgt op een snelweg?',
      ar: 'ماذا يجب أن تفعل إذا تعطلت سيارتك على طريق سريع؟'
    },
    options: [
      {
        id: 'q-mr-3o1',
        text: {
          en: 'Stay in your vehicle',
          nl: 'Blijf in je voertuig',
          ar: 'ابق في سيارتك'
        }
      },
      {
        id: 'q-mr-3o2',
        text: {
          en: 'Get out and stand behind the barrier',
          nl: 'Stap uit en ga achter de vangrail staan',
          ar: 'اخرج ووقف خلف الحاجز'
        }
      },
      {
        id: 'q-mr-3o3',
        text: {
          en: 'Walk along the motorway to find help',
          nl: 'Loop langs de snelweg om hulp te zoeken',
          ar: 'امش على طول الطريق السريع للبحث عن المساعدة'
        }
      },
      {
        id: 'q-mr-3o4',
        text: {
          en: 'Try to repair the vehicle yourself',
          nl: 'Probeer het voertuig zelf te repareren',
          ar: 'حاول إصلاح السيارة بنفسك'
        }
      }
    ],
    correctAnswerId: 'q-mr-3o2',
    explanation: {
      en: 'If your vehicle breaks down on a motorway, you should get out of your vehicle and stand behind the safety barrier. Call for assistance using the emergency phones.',
      nl: 'Als je voertuig pech krijgt op een snelweg, moet je uitstappen en achter de vangrail gaan staan. Bel om hulp met behulp van de noodtelefoons.',
      ar: 'إذا تعطلت سيارتك على طريق سريع، يجب عليك الخروج من سيارتك والوقوف خلف الحاجز الأمني. اتصل للمساعدة باستخدام هواتف الطوارئ.'
    },
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-breakdown.jpg'
  },
  {
    id: 'q-mr-4',
    text: {
      en: 'What is the purpose of the hard shoulder on a motorway?',
      nl: 'Wat is het doel van de vluchtstrook op een snelweg?',
      ar: 'ما هو الغرض من الكتف الصلب على الطريق السريع؟'
    },
    options: [
      {
        id: 'q-mr-4o1',
        text: {
          en: 'For overtaking slow vehicles',
          nl: 'Voor het inhalen van langzame voertuigen',
          ar: 'لتجاوز المركبات البطيئة'
        }
      },
      {
        id: 'q-mr-4o2',
        text: {
          en: 'For emergency stops and breakdowns',
          nl: 'Voor noodstops en pech',
          ar: 'للتوقفات الطارئة والأعطال'
        }
      },
      {
        id: 'q-mr-4o3',
        text: {
          en: 'For parking when tired',
          nl: 'Voor parkeren wanneer je moe bent',
          ar: 'للوقوف عند التعب'
        }
      },
      {
        id: 'q-mr-4o4',
        text: {
          en: 'For making phone calls',
          nl: 'Voor het maken van telefoongesprekken',
          ar: 'لإجراء المكالمات الهاتفية'
        }
      }
    ],
    correctAnswerId: 'q-mr-4o2',
    explanation: {
      en: 'The hard shoulder is reserved for emergency stops and breakdowns only. It should not be used for normal driving, overtaking, or parking.',
      nl: 'De vluchtstrook is alleen gereserveerd voor noodstops en pech. Het mag niet worden gebruikt voor normaal rijden, inhalen of parkeren.',
      ar: 'الكتف الصلب محجوز فقط للتوقفات الطارئة والأعطال. لا يجب استخدامه للقيادة العادية أو التجاوز أو الوقوف.'
    },
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-hard-shoulder.jpg'
  },
  {
    id: 'q-mr-5',
    text: {
      en: 'What should you do when approaching a motorway exit?',
      nl: 'Wat moet je doen bij het naderen van een snelwegafslag?',
      ar: 'ماذا يجب أن تفعل عند الاقتراب من مخرج طريق سريع؟'
    },
    options: [
      {
        id: 'q-mr-5o1',
        text: {
          en: 'Speed up to get through quickly',
          nl: 'Versnel om er snel doorheen te komen',
          ar: 'اسرع للعبور بسرعة'
        }
      },
      {
        id: 'q-mr-5o2',
        text: {
          en: 'Move to the left lane early',
          nl: 'Ga vroeg naar de linker rijstrook',
          ar: 'انتقل إلى الممر الأيسر مبكرا'
        }
      },
      {
        id: 'q-mr-5o3',
        text: {
          en: 'Move to the right lane early',
          nl: 'Ga vroeg naar de rechter rijstrook',
          ar: 'انتقل إلى الممر الأيمن مبكرا'
        }
      },
      {
        id: 'q-mr-5o4',
        text: {
          en: 'Honk your horn to signal your intention',
          nl: 'Toeter om je voornemen aan te geven',
          ar: 'استخدم البوق للإشارة إلى نيتك'
        }
      }
    ],
    correctAnswerId: 'q-mr-5o3',
    explanation: {
      en: 'When approaching a motorway exit, you should move to the right lane early and reduce your speed gradually to safely exit the motorway.',
      nl: 'Bij het naderen van een snelwegafslag moet je vroeg naar de rechter rijstrook gaan en je snelheid geleidelijk verminderen om veilig van de snelweg af te slaan.',
      ar: 'عند الاقتراب من مخرج طريق سريع، يجب عليك الانتقال إلى الممر الأيمن مبكرا وتقليل سرعتك تدريجيا للخروج بأمان من الطريق السريع.'
    },
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-route-signage.jpg'
  },
  {
    id: 'q-mr-6',
    text: {
      en: 'What should you do when entering a motorway?',
      nl: 'Wat moet je doen bij het oprijden van een snelweg?',
      ar: 'ماذا يجب أن تفعل عند دخول طريق سريع؟'
    },
    options: [
      {
        id: 'q-mr-6o1',
        text: {
          en: 'Stop and wait for a large gap',
          nl: 'Stop en wacht op een grote opening',
          ar: 'توقف وانتظر فجوة كبيرة'
        }
      },
      {
        id: 'q-mr-6o2',
        text: {
          en: 'Accelerate to match motorway speed',
          nl: 'Versnel om de snelwegsnelheid te evenaren',
          ar: 'اسرع لمطابقة سرعة الطريق السريع'
        }
      },
      {
        id: 'q-mr-6o3',
        text: {
          en: 'Slow down to let other vehicles pass',
          nl: 'Vertraag om andere voertuigen te laten passeren',
          ar: 'أبطئ للسماح للمركبات الأخرى بالمرور'
        }
      },
      {
        id: 'q-mr-6o4',
        text: {
          en: 'Honk your horn to signal your intention',
          nl: 'Toeter om je voornemen aan te geven',
          ar: 'استخدم البوق للإشارة إلى نيتك'
        }
      }
    ],
    correctAnswerId: 'q-mr-6o2',
    explanation: {
      en: 'When entering a motorway, you should accelerate to match the speed of traffic on the motorway and merge safely into a gap.',
      nl: 'Bij het oprijden van een snelweg moet je versnellen om de snelheid van het verkeer op de snelweg te evenaren en veilig in een opening in te voegen.',
      ar: 'عند دخول طريق سريع، يجب عليك التسريع لمطابقة سرعة المرور على الطريق السريع والاندماج بأمان في فجوة.'
    },
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-onramp-yield.jpg'
  },
  {
    id: 'q-mr-7',
    text: {
      en: 'What does a variable speed limit sign on a motorway mean?',
      nl: 'Wat betekent een variabel snelheidslimietbord op een snelweg?',
      ar: 'ماذا تعني علامة حد السرعة المتغير على الطريق السريع؟'
    },
    options: [
      {
        id: 'q-mr-7o1',
        text: {
          en: 'The speed limit is optional',
          nl: 'De snelheidslimiet is optioneel',
          ar: 'حد السرعة اختياري'
        }
      },
      {
        id: 'q-mr-7o2',
        text: {
          en: 'You must follow the displayed speed limit',
          nl: 'Je moet de weergegeven snelheidslimiet volgen',
          ar: 'يجب عليك اتباع حد السرعة المعروض'
        }
      },
      {
        id: 'q-mr-7o3',
        text: {
          en: 'The speed limit only applies to trucks',
          nl: 'De snelheidslimiet geldt alleen voor vrachtwagens',
          ar: 'حد السرعة ينطبق فقط على الشاحنات'
        }
      },
      {
        id: 'q-mr-7o4',
        text: {
          en: 'The speed limit only applies at night',
          nl: 'De snelheidslimiet geldt alleen \'s nachts',
          ar: 'حد السرعة ينطبق فقط ليلا'
        }
      }
    ],
    correctAnswerId: 'q-mr-7o2',
    explanation: {
      en: 'Variable speed limit signs on motorways display mandatory speed limits that you must follow. These are used to manage traffic flow and improve safety.',
      nl: 'Variabele snelheidslimietborden op snelwegen tonen verplichte snelheidslimieten die je moet volgen. Deze worden gebruikt om de verkeersstroom te beheren en de veiligheid te verbeteren.',
      ar: 'علامات حد السرعة المتغير على الطرق السريعة تعرض حدود السرعة الإلزامية التي يجب عليك اتباعها. تستخدم لإدارة تدفق المرور وتحسين السلامة.'
    },
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-gantry-lane-closed.jpg'
  },
  {
    id: 'q-mr-8',
    text: {
      en: 'What should you do if you miss your motorway exit?',
      nl: 'Wat moet je doen als je je snelwegafslag mist?',
      ar: 'ماذا يجب أن تفعل إذا فوتت مخرج الطريق السريع؟'
    },
    options: [
      {
        id: 'q-mr-8o1',
        text: {
          en: 'Reverse back to the exit',
          nl: 'Rijd achteruit terug naar de afslag',
          ar: 'تراجع للعودة إلى المخرج'
        }
      },
      {
        id: 'q-mr-8o2',
        text: {
          en: 'Stop and turn around',
          nl: 'Stop en keer om',
          ar: 'توقف واستدر'
        }
      },
      {
        id: 'q-mr-8o3',
        text: {
          en: 'Continue to the next exit',
          nl: 'Ga door naar de volgende afslag',
          ar: 'استمر إلى المخرج التالي'
        }
      },
      {
        id: 'q-mr-8o4',
        text: {
          en: 'Use the hard shoulder to turn around',
          nl: 'Gebruik de vluchtstrook om om te keren',
          ar: 'استخدم الكتف الصلب للاستدارة'
        }
      }
    ],
    correctAnswerId: 'q-mr-8o3',
    explanation: {
      en: 'If you miss your motorway exit, you should continue to the next exit and find an alternative route. Never reverse, stop, or turn around on a motorway.',
      nl: 'Als je je snelwegafslag mist, moet je doorgaan naar de volgende afslag en een alternatieve route vinden. Keer nooit achteruit, stop of keer om op een snelweg.',
      ar: 'إذا فوتت مخرج الطريق السريع، يجب عليك المتابعة إلى المخرج التالي والعثور على مسار بديل. لا تتراجع أبدا أو تتوقف أو تستدير على طريق سريع.'
    },
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-exit-approach.jpg'
  },
  {
    id: 'q-mr-9',
    text: {
      en: 'What is the purpose of lane markings on a motorway?',
      nl: 'Wat is het doel van rijstrookmarkeringen op een snelweg?',
      ar: 'ما هو الغرض من علامات الممرات على الطريق السريع؟'
    },
    options: [
      {
        id: 'q-mr-9o1',
        text: {
          en: 'To separate different types of vehicles',
          nl: 'Om verschillende soorten voertuigen te scheiden',
          ar: 'لفصل أنواع مختلفة من المركبات'
        }
      },
      {
        id: 'q-mr-9o2',
        text: {
          en: 'To organize traffic flow and prevent accidents',
          nl: 'Om de verkeersstroom te organiseren en ongevallen te voorkomen',
          ar: 'لتنظيم تدفق المرور ومنع الحوادث'
        }
      },
      {
        id: 'q-mr-9o3',
        text: {
          en: 'To create parking spaces',
          nl: 'Om parkeerplaatsen te creëren',
          ar: 'لإنشاء أماكن وقوف'
        }
      },
      {
        id: 'q-mr-9o4',
        text: {
          en: 'To mark emergency stopping areas',
          nl: 'Om noodstopgebieden te markeren',
          ar: 'لتحديد مناطق التوقف الطارئ'
        }
      }
    ],
    correctAnswerId: 'q-mr-9o2',
    explanation: {
      en: 'Lane markings on motorways help organize traffic flow, prevent accidents, and ensure safe driving by clearly defining where vehicles should drive.',
      nl: 'Rijstrookmarkeringen op snelwegen helpen de verkeersstroom te organiseren, ongevallen te voorkomen en veilig rijden te waarborgen door duidelijk te definiëren waar voertuigen moeten rijden.',
      ar: 'علامات الممرات على الطرق السريعة تساعد في تنظيم تدفق المرور ومنع الحوادث وضمان القيادة الآمنة من خلال تحديد مكان قيادة المركبات بوضوح.'
    },
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-chevrons.jpg'
  },
  {
    id: 'q-mr-10',
    text: {
      en: 'What should you do when overtaking on a motorway?',
      nl: 'Wat moet je doen bij het inhalen op een snelweg?',
      ar: 'ماذا يجب أن تفعل عند التجاوز على طريق سريع؟'
    },
    options: [
      {
        id: 'q-mr-10o1',
        text: {
          en: 'Use the hard shoulder',
          nl: 'Gebruik de vluchtstrook',
          ar: 'استخدم الكتف الصلب'
        }
      },
      {
        id: 'q-mr-10o2',
        text: {
          en: 'Use the left lane',
          nl: 'Gebruik de linker rijstrook',
          ar: 'استخدم الممر الأيسر'
        }
      },
      {
        id: 'q-mr-10o3',
        text: {
          en: 'Use the right lane',
          nl: 'Gebruik de rechter rijstrook',
          ar: 'استخدم الممر الأيمن'
        }
      },
      {
        id: 'q-mr-10o4',
        text: {
          en: 'Honk your horn continuously',
          nl: 'Toeter continu',
          ar: 'استخدم البوق باستمرار'
        }
      }
    ],
    correctAnswerId: 'q-mr-10o2',
    explanation: {
      en: 'When overtaking on a motorway, you should use the left lane (the lane to the left of the vehicle you are overtaking).',
      nl: 'Bij het inhalen op een snelweg moet je de linker rijstrook gebruiken (de rijstrook links van het voertuig dat je inhaalt).',
      ar: 'عند التجاوز على طريق سريع، يجب عليك استخدام الممر الأيسر (الممر على يسار المركبة التي تتجاوزها).'
    },
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-lane-discipline.jpg'
  },
  {
    id: 'q-mr-11',
    text: {
      en: 'What should you do when being overtaken on a motorway?',
      nl: 'Wat moet je doen wanneer je wordt ingehaald op een snelweg?',
      ar: 'ماذا يجب أن تفعل عندما يتم تجاوزك على طريق سريع؟'
    },
    options: [
      {
        id: 'q-mr-11o1',
        text: {
          en: 'Speed up to prevent being overtaken',
          nl: 'Versnel om te voorkomen dat je wordt ingehaald',
          ar: 'اسرع لمنع تجاوزك'
        }
      },
      {
        id: 'q-mr-11o2',
        text: {
          en: 'Move to the right lane',
          nl: 'Ga naar de rechter rijstrook',
          ar: 'انتقل إلى الممر الأيمن'
        }
      },
      {
        id: 'q-mr-11o3',
        text: {
          en: 'Maintain your speed and position',
          nl: 'Behoud je snelheid en positie',
          ar: 'حافظ على سرعتك وموقعك'
        }
      },
      {
        id: 'q-mr-11o4',
        text: {
          en: 'Honk your horn to signal your position',
          nl: 'Toeter om je positie aan te geven',
          ar: 'استخدم البوق للإشارة إلى موقعك'
        }
      }
    ],
    correctAnswerId: 'q-mr-11o3',
    explanation: {
      en: 'When being overtaken on a motorway, you should maintain your speed and position. Do not speed up or change lanes unnecessarily.',
      nl: 'Wanneer je wordt ingehaald op een snelweg, moet je je snelheid en positie behouden. Versnel niet of wissel niet onnodig van rijstrook.',
      ar: 'عندما يتم تجاوزك على طريق سريع، يجب عليك الحفاظ على سرعتك وموقعك. لا تسرع أو تغير الممرات دون داع.'
    },
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-following-truck.jpg'
  },
  {
    id: 'q-mr-12',
    text: {
      en: 'What should you do if you see an emergency vehicle on a motorway?',
      nl: 'Wat moet je doen als je een hulpdienstvoertuig ziet op een snelweg?',
      ar: 'ماذا يجب أن تفعل إذا رأيت مركبة طوارئ على طريق سريع؟'
    },
    options: [
      {
        id: 'q-mr-12o1',
        text: {
          en: 'Ignore it and continue driving',
          nl: 'Negeer het en blijf rijden',
          ar: 'تجاهله واستمر في القيادة'
        }
      },
      {
        id: 'q-mr-12o2',
        text: {
          en: 'Move to the right and slow down',
          nl: 'Ga naar rechts en vertraag',
          ar: 'انتقل إلى اليمين وأبطئ'
        }
      },
      {
        id: 'q-mr-12o3',
        text: {
          en: 'Speed up to get out of the way',
          nl: 'Versnel om uit de weg te gaan',
          ar: 'اسرع للخروج من الطريق'
        }
      },
      {
        id: 'q-mr-12o4',
        text: {
          en: 'Stop immediately',
          nl: 'Stop onmiddellijk',
          ar: 'توقف فورا'
        }
      }
    ],
    correctAnswerId: 'q-mr-12o2',
    explanation: {
      en: 'If you see an emergency vehicle on a motorway, you should move to the right lane and slow down to allow it to pass safely.',
      nl: 'Als je een hulpdienstvoertuig ziet op een snelweg, moet je naar de rechter rijstrook gaan en vertragen om het veilig te laten passeren.',
      ar: 'إذا رأيت مركبة طوارئ على طريق سريع، يجب عليك الانتقال إلى الممر الأيمن والتباطؤ للسماح لها بالمرور بأمان.'
    },
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-emergency-response.jpg'
  },
  {
    id: 'q-mr-13',
    text: {
      en: 'When you see emergency vehicles approaching on a motorway with flashing lights, what should you do?',
      nl: 'Wat moet je doen wanneer je hulpdienstvoertuigen met zwaailichten op je ziet afkomen op een snelweg?',
      ar: 'ماذا يجب أن تفعل عندما ترى مركبات طوارئ تقترب مع أضواء وامضة على طريق سريع؟'
    },
    options: [
      {
        id: 'q-mr-13o1',
        text: {
          en: 'Stay in your lane and let them pass',
          nl: 'Blijf in je rijstrook en laat ze passeren',
          ar: 'ابق في ممرك واتركهم يمرون'
        }
      },
      {
        id: 'q-mr-13o2',
        text: {
          en: 'Create an emergency corridor by moving to the left/right and slow down',
          nl: 'Maak een noodhulpstrook door naar links/rechts te gaan en te vertragen',
          ar: 'أنشئ ممر طوارئ بالانتقال إلى اليسار/اليمين والتباطؤ'
        }
      },
      {
        id: 'q-mr-13o3',
        text: {
          en: 'Speed up to clear the road',
          nl: 'Versnel om de weg vrij te maken',
          ar: 'اسرع لإفساح الطريق'
        }
      }
    ],
    correctAnswerId: 'q-mr-13o2',
    explanation: {
      en: 'When emergency vehicles approach with flashing lights, you must create an emergency corridor (noodhulpstrook) by moving to the left or right and slowing down to allow safe passage.',
      nl: 'Wanneer hulpdienstvoertuigen met zwaailichten naderen, moet je een noodhulpstrook creëren door naar links of rechts te gaan en te vertragen om veilig te kunnen passeren.',
      ar: 'عندما تقترب مركبات الطوارئ مع أضواء وامضة، يجب عليك إنشاء ممر طوارئ بالانتقال إلى اليسار أو اليمين والتباطؤ للسماح بالمرور الآمن.'
    },
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-emergency-corridor.jpg'
  },
  {
    id: 'q-mr-14',
    text: {
      en: 'What is the recommended minimum safe following distance at 100 km/h on a motorway?',
      nl: 'Wat is de aanbevolen minimale veilige volafstand op 100 km/u op een snelweg?',
      ar: 'ما هي المسافة الآمنة الدنيا الموصى بها عند 100 كم/س على طريق سريع؟'
    },
    options: [
      {
        id: 'q-mr-14o1',
        text: {
          en: '30 meters',
          nl: '30 meter',
          ar: '30 متر'
        }
      },
      {
        id: 'q-mr-14o2',
        text: {
          en: '60 meters',
          nl: '60 meter',
          ar: '60 متر'
        }
      },
      {
        id: 'q-mr-14o3',
        text: {
          en: '100 meters',
          nl: '100 meter',
          ar: '100 متر'
        }
      }
    ],
    correctAnswerId: 'q-mr-14o2',
    explanation: {
      en: 'At 100 km/h, the recommended minimum safe following distance is 60 meters. This gives you enough time to react and brake safely if the vehicle ahead stops suddenly.',
      nl: 'Op 100 km/u is de aanbevolen minimale veilige volafstand 60 meter. Dit geeft je genoeg tijd om te reageren en veilig te remmen als het voertuig voor je plotseling stopt.',
      ar: 'عند 100 كم/س، فإن المسافة الآمنة الدنيا الموصى بها هي 60 متر. هذا يعطيك وقتا كافيا للرد والفرملة بأمان إذا توقفت السيارة أمامك فجأة.'
    },
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/q-mr-14-following-distance.jpg'
  },
  {
    id: 'q-mr-15',
    text: {
      en: 'On a motorway with multiple lanes, which lane should you normally drive in?',
      nl: 'Op een snelweg met meerdere rijstroken, in welke rijstrook moet je normaal rijden?',
      ar: 'على طريق سريع بعدة ممرات، في أي ممر يجب أن تقود عادة؟'
    },
    options: [
      {
        id: 'q-mr-15o1',
        text: {
          en: 'The right lane',
          nl: 'De rechter rijstrook',
          ar: 'الممر الأيمن'
        }
      },
      {
        id: 'q-mr-15o2',
        text: {
          en: 'The left lane',
          nl: 'De linker rijstrook',
          ar: 'الممر الأيسر'
        }
      },
      {
        id: 'q-mr-15o3',
        text: {
          en: 'The middle lane',
          nl: 'De middelste rijstrook',
          ar: 'الممر الأوسط'
        }
      }
    ],
    correctAnswerId: 'q-mr-15o1',
    explanation: {
      en: 'You should normally drive in the right lane and only use the left lanes for overtaking. This is the "houden rechts" (keep right) rule.',
      nl: 'Je moet normaal in de rechter rijstrook rijden en de linker rijstroken alleen voor inhalen gebruiken. Dit is de regel "houden rechts".',
      ar: 'يجب أن تقود عادة في الممر الأيمن واستخدام الممرات اليسرى فقط للتجاوز. هذه هي قاعدة "الاحتفاظ باليمين".'
    },
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/q-mr-15-lane-discipline.jpg'
  },
  {
    id: 'q-mr-16',
    text: {
      en: 'When merging onto a motorway, what must you check before changing lanes?',
      nl: 'Wat moet je controleren voordat je van rijstrook verandert bij het oprijden van een snelweg?',
      ar: 'ماذا يجب أن تتحقق منه قبل تغيير الممر عند الدخول إلى طريق سريع؟'
    },
    options: [
      {
        id: 'q-mr-16o1',
        text: {
          en: 'Mirrors only',
          nl: 'Alleen spiegels',
          ar: 'المرايا فقط'
        }
      },
      {
        id: 'q-mr-16o2',
        text: {
          en: 'Mirrors and your blind spot over your shoulder',
          nl: 'Spiegels en je dode hoek over je schouder',
          ar: 'المرايا والنقطة العمياء على كتفك'
        }
      },
      {
        id: 'q-mr-16o3',
        text: {
          en: 'Speed of traffic only',
          nl: 'Alleen snelheid van verkeer',
          ar: 'سرعة المرور فقط'
        }
      }
    ],
    correctAnswerId: 'q-mr-16o2',
    explanation: {
      en: 'Before changing lanes when merging, you must check both mirrors and your blind spot over your shoulder to ensure no vehicles are in your intended path.',
      nl: 'Voordat je van rijstrook verandert bij het invoegen, moet je zowel de spiegels als je dode hoek over je schouder controleren om ervoor te zorgen dat er geen voertuigen in je beoogde pad zijn.',
      ar: 'قبل تغيير الممر عند الاندماج، يجب عليك التحقق من المرايا والنقطة العمياء على كتفك للتأكد من عدم وجود مركبات في مسارك المقصود.'
    },
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-overtaking.jpg'
  },
  {
    id: 'q-mr-17',
    text: {
      en: 'What should you do when driving on a wet motorway with reduced grip?',
      nl: 'Wat moet je doen wanneer je op een natte snelweg rijdt met verminderde grip?',
      ar: 'ماذا يجب أن تفعل عند القيادة على طريق سريع مبلل بقبضة منخفضة؟'
    },
    options: [
      {
        id: 'q-mr-17o1',
        text: {
          en: 'Maintain speed and use hazard lights',
          nl: 'Behoud snelheid en gebruik waarschuwingslichten',
          ar: 'حافظ على السرعة واستخدم أضواء التحذير'
        }
      },
      {
        id: 'q-mr-17o2',
        text: {
          en: 'Reduce speed significantly and increase following distance',
          nl: 'Verminder snelheid aanzienlijk en vergroot volafstand',
          ar: 'قلل السرعة بشكل كبير وزيادة المسافة الآمنة'
        }
      },
      {
        id: 'q-mr-17o3',
        text: {
          en: 'Exit the motorway immediately',
          nl: 'Verlaat de snelweg onmiddellijk',
          ar: 'اخرج من الطريق السريع فورا'
        }
      }
    ],
    correctAnswerId: 'q-mr-17o2',
    explanation: {
      en: 'On wet motorways with reduced traction, you must reduce speed significantly and increase your following distance. Wet road conditions increase stopping distance and reduce grip.',
      nl: 'Op natte snelwegen met verminderde tractie moet je de snelheid aanzienlijk verminderen en je volafstand vergroten. Natte wegomstandigheden vergroten de remafstand en verminderen de grip.',
      ar: 'على الطرق السريعة المبللة بقبضة منخفضة، يجب عليك تقليل السرعة بشكل كبير وزيادة المسافة الآمنة. تزيد ظروف الطرق المبللة من مسافة الفرملة وتقلل من القبضة.'
    },
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/q-mr-17-wet-motorway.jpg'
  }
];

























